import { Typography } from '@mui/material';
import { useState } from 'react';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { GridRowsImage } from '@shared/components/grid/overlays/components/GridRowsImage';
import { ExcludedLenders, ExcludedLendersContainer } from '@styles/ContactManager/DealCalculator/LendersStyles';
import { ExcludedLender } from '../LenderSection/ExcludedLender';
import { IIneligibleLender } from '../../../../models/IneligibleLender';

interface IExcludedLenderSection {
  ineligibleLenders: IIneligibleLender[];
  reloadDealCalculator: () => void;
  leadId?: string;
}

export const ExcludedLenderSection = ({
  ineligibleLenders,
  leadId,
  reloadDealCalculator
}: IExcludedLenderSection) => {
  const [expanded, setExpandedStatus] = useState(false);

  return (
    <ExcludedLenders>
      <Typography
        variant="h3"
        sx={{ m: '20px 20px 8px', cursor: 'pointer' }}
        onClick={() => setExpandedStatus(prevStatus => !prevStatus)}
      >
        Excluded Lenders
        {expanded ? <ExpandLess /> : <ExpandMore />}
      </Typography>

      {expanded && (
        <ExcludedLendersContainer>
          {ineligibleLenders?.length ? (
            ineligibleLenders?.map((lender) => (
              <ExcludedLender
                key={lender.id}
                leadId={leadId}
                lender={lender}
                reloadDealCalculator={reloadDealCalculator}
                onSave={() => true}
              />
            ))
          ) : (
            <GridRowsImage label="No Lenders" />
          )}
        </ExcludedLendersContainer>
      )}
    </ExcludedLenders>
  );
};